import React from 'react';
import { debounce, Grid } from '@material-ui/core';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomTextField from '../../shared/CustomTextField';
import CustomCheckbox from '../../shared/CustomCheckbox';

const ScoreParametersDefault = ({ handleChange, data }) => {
  const parameters = [
    { type: 'activity', label: 'Activity Stars' },
    { type: 'consistency', label: 'Consistency Stars' },
    { type: 'guide', label: 'Guide Stars' },
    { type: 'capstone', label: 'Capstone Stars' },
    { type: 'checkin', label: 'Checkin Stars' },
    { type: 'story', label: 'Story Stars' },
  ];

  return (
    <Grid container direction="column">
      <Grid item style={{ marginBottom: '16px' }}>
        <CustomPopupText
          text="Score parameters"
          fontSize="16px"
          fontWeight="700"
          lineHeight="22.4px"
          color="rgba(16, 24, 43, 1)"
        />
      </Grid>
      <Grid item>
        <Grid container direction="row" alignItems="center" justifyContent="center" style={{ height: '5vh' }}>
          <Grid item xs={2} container justifyContent="flex-start">
            <CustomPopupText
              text="Parameters Name"
              fontSize="12px"
              fontWeight="600"
              lineHeight="16.8px"
              color="rgba(16, 24, 43, 1)"
            />
          </Grid>
          <Grid item xs={2} container justifyContent="center">
            <CustomPopupText
              text="Is Score Parameter"
              fontSize="12px"
              fontWeight="600"
              lineHeight="16.8px"
              color="rgba(16, 24, 43, 1)"
            />
          </Grid>
          <Grid item xs={2} container justifyContent="center">
            <CustomPopupText
              text="Is Displayed on App"
              fontSize="12px"
              fontWeight="600"
              lineHeight="16.8px"
              color="rgba(16, 24, 43, 1)"
            />
          </Grid>
          <Grid item xs={6} container justifyContent="flex-start">
            <CustomPopupText
              text="Logic"
              fontSize="12px"
              fontWeight="600"
              lineHeight="16.8px"
              color="rgba(16, 24, 43, 1)"
            />
          </Grid>
        </Grid>
      </Grid>

      {parameters.map(({ type, label }) => {
        const param = data?.scoreBreakupParameters?.find((item) => item.type === type);
        const isEnabled = param !== undefined;
        const isDisplayed = isEnabled && param.isDisplayed;
        const defaultValue = isEnabled ? JSON.stringify(param.logic, undefined, 2) : '';

        return (
          <Grid item key={type}>
            <Grid container direction="row" alignItems="flex-start" justifyContent="flex-start">
              <Grid item xs={2} container justifyContent="flex-start">
                <CustomPopupText text={label} required={type === 'consistency' && isDisplayed} />
              </Grid>
              <Grid item xs={2} container justifyContent="center" alignItems="flex-start">
                <CustomCheckbox size="small" name={`${type}Enabled`} selected={isEnabled} handleChange={handleChange} />
              </Grid>
              <Grid item xs={2} container justifyContent="center" alignItems="flex-start">
                <CustomCheckbox
                  name={`${type}Displayed`}
                  selected={isDisplayed}
                  handleChange={handleChange}
                  inputProps={{ 'aria-label': 'isDisplayed' }}
                  disabled={!isEnabled}
                />
              </Grid>
              <Grid item xs={6} container justifyContent="flex-start">
                <Grid container direction="column">
                  <Grid item>
                    <CustomPopupText text={`Enter ${label} Logic`} />
                  </Grid>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                  <CustomTextField
                    name={`${type}Stars`}
                    rows={1}
                    placeholder={`${label}`}
                    id={`${type}_stars_id`}
                    height="47px"
                    handleChange={debounce(handleChange, 300)}
                    width="100%"
                    disabled={!isEnabled}
                    defaultValue={defaultValue}
                    multiline
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ScoreParametersDefault;
